<div class="file-button-container">
    <div class="displayFile">
        <i class="bi bi-file-earmark-check fs-3"></i>
        <p class="filename">{{this.selectedFileName}}</p>                 
    </div>
    <div class="deleteContainer">
        <button class="delete-button" (click)="deleteFile()" title="Delete file">
        <i class="bi bi-trash3"></i>
        </button>
    </div>
</div>